export default __webpack_public_path__ + "static/logo-4ca411f5449f14c965916cff99454935.webp";